import useServiceFactory from "../serviceFactory";

const apiUrl = `/administracion/RelojChecador`;

const useApiRelojChecador = () => {
    const service = useServiceFactory({
        uri: process.env.REACT_APP_API_URL
    });

    return {
        obtener: async (params) =>
            service.get(`${apiUrl}/obtenerInformacion`, {
                params,
                showLoading: true
            }),

        obtenerEmpleadosPorJefe: async (jefeId) =>
            service.get(`/source/empleadosPorJefe`, {
                params: { jefeId },
                showLoading: false
    })

    };
};

export default useApiRelojChecador;
